import React from 'react';
import TransfusionCycle from '../assets/img/transfusion-medicine-cycle.jpg';
import TransfusionMedicine from '../assets/img/transfusion-medicine-1.jpg';
import TransfusionMedicine1 from '../assets/img/transplantation-medicine.jpg';
import Transfusion2 from '../assets/img/Transfusion2.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

function TransplantationMedicine() {
    return (
        <>
            <Header1 />
                <section className='blog-wrapper news-wrapper section-padding'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-md-12">
                                <div className="news-content">
                                    <div className="section-heading marginbot20">
                                        <p className='mb-0'><strong>Transfusion </strong>and <strong>Transplantation</strong> Medicine </p><h5></h5><p className='mb-3'></p>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p className='mb-3'>
                                                </p><h5>Transfusion Medicine:</h5>
                                            <p className='mb-3'></p>
                                            
                                            <img src={TransfusionCycle} className="alignleft" alt="" style={{height:"200px", width:"200px"}} />
                                            <p className='mb-3'>
                                                Transfusion medicine (or transfusiology) is the branch of medicine that is concerned with the transfusion of blood and blood components. Transfusions are used for various medical conditions to replace lost components of the blood. Early transfusions used whole blood, but modern medical practice commonly uses only components of the blood, such as red blood cells, white blood cells, plasma, clotting factors, and platelets. Transfusion Medicine deals in blood product selection and management, immunohematology, apheresis, stem cell collection, cellular therapy, and coagulation 
                                            </p>
                                            
                                        </div>
                                        <div className="col-md-6 pt-2">
                                            <img src={TransfusionMedicine} alt="" className='w-100' />
                                        </div>
                                    </div>
                                    <div className="divider my-2"></div>
                                    <div className="row">
                                        <div className="col-md-5">
                                            <p className='mb-3'>
                                                </p><h5>Transplantation Medicine:</h5>
                                            <p className='mb-3'></p>
                                            <img src={TransfusionMedicine1} alt="" className='w-100' />
                                        </div>
                                        <div className="col-md-6">
                                            <p className='mb-3'>
                                                &nbsp;
                                            </p>
                                            <img src={Transfusion2} className="alignright" alt="" style={{height:"200px", width:"200px"}} />
                                            <p className='mb-3'>
                                                Transplantation medicine is one of the most challenging and complex areas of modern medicine. Some of the key areas for medical management are the problems of transplant rejection, during which the body has an immune response to the transplanted organ, possibly leading to transplant failure and the need to immediately remove the organ from the recipient. When possible, transplant rejection can be reduced through serotyping to determine the most appropriate donor-recipient match and through the use of immunosuppressant drugs. The transplantation may be autologous (an individual's own blood cells saved earlier), allogeneic (blood cells donated by someone else with matching HLA), or syngeneic (blood cells donated by an identical twin). 
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <p className='mb-3'>
                                </p></div>
                            </div>
                        </div>
                    </div>
                </section>
            <Footer1 />
        </>
    );
}

export default TransplantationMedicine;
